<template>
  <div :class="{previewArea: true, tablet: responsive === 'tablet'}">
    <div class="setPreview">
      <div :class="{header: true, open: open}" :style="responsive === 'tablet' && menuBg" :data-arrange="skin.menu">
        <div class="homeBar" :style="responsive !== 'tablet' && headerBg">
          <div v-if="site.logo !== ''" class="home"><span><img :src="site.logo" alt="" /></span></div>
          <div v-else class="message"><span>{{locale.preview_nologo}}</span></div>
        </div>
        <button type="button" class="btnMenu" @click="onClickMenu">
          <span class="bar" :style="{backgroundColor: menuBtnColor}"></span>
          <span class="bar" :style="{backgroundColor: menuBtnColor}"></span>
          <span class="bar" :style="{backgroundColor: menuBtnColor}"></span>
        </button>
        <div v-show="open" class="dimm" @click="onClickMenu" :style="{backgroundColor: colors.dimm}"></div>
        <div class="nav" :data-active_menu="skin.activeMenuType" :style="{...responsive !== 'tablet' ? menuBg : {backgroundColor: 'transparent'}, color: colors.menuText}">
          <RenderMenu
            v-if="renderData"
            :responsive="responsive"
            :activeTabletMenu="activeTabletMenu"
            :activeTabletMenuAcc="activeTabletMenuAcc" />
        </div>
      </div>
      <div class="previewContent">
        <slot name="previewContent"></slot>
      </div>
      <div class="footer" :style="{backgroundColor: colors.footerBg, color: colors.footerText}" v-html="footer.copyright[lang]">
      </div>
    </div>
    <p class="info">* {{locale.preview_msg_fuller}}</p>
  </div>
</template>

<script>
import RenderMenu from '@/components/Menu/Render.vue'

export default {
  name: 'Preview',
  props: [
    'responsive',
    'skin',
    'colors',
    'imgs',
    'site',
    'content',
    'c'
  ],
  components: {
    RenderMenu
  },
  computed: {
    lang () {
      return this.$store.getters['preview/lang']
    },
    footer () {
      return this.$store.state.setting.footer
    },
    locale () {
      return this.$store.state.service.locale.data
    },
    renderData () {
      return this.$store.state.setting.main.menu !== ''
    },
    menuBtnColor () {
      return this.open ? this.colors.menuBtn2 : this.colors.menuBtn
    },
    headerBg () {
      const isTablet = this.responsive === 'tablet'
      return {
        backgroundColor: this.colors.headerBg,
        backgroundImage: `url(${this.imgs.headerBg})`,
        backgroundSize: this.imgs.headerBgSize,
        backgroundRepeat: this.imgs.headerBgRepeat,
        backgroundPosition: this.imgs.headerBgPosition
      }
    },
    menuBg () {
      return {
        backgroundColor: this.colors.menuBg,
        backgroundImage: `url(${this.imgs.menuBg})`,
        backgroundSize: this.imgs.menuBgSize,
        backgroundRepeat: this.imgs.menuBgRepeat,
        backgroundPosition: this.imgs.menuBgPosition
      }
    },
    activeTabletMenu () {
      return this.responsive === 'tablet' && {
        color: this.colors.activeMenuText || this.colors.menuBg,
        backgroundColor: this.colors.activeMenuBg || this.colors.menuText
      }
    },
    activeTabletMenuAcc () {
      const activeMenuBg = this.colors.activeMenuBg || this.colors.menuText
      return this.responsive === 'tablet' && {
        background: `radial-gradient(20px at left top, rgba(0, 0, 0, 0) 96%, ${activeMenuBg}) left top`
      }
    }
  },
  data () {
    return {
      open: false
    }
  },
  methods: {
    onClickMenu () {
      this.open = !this.open
      this.$store.commit('menu/previewState', this.open)
    }
  }
}
</script>
